import { Routes } from '@angular/router';
import { SettingsPageComponent } from './settings-page.component';
import {
  AccessControlSettingsRouteName,
  AlertSettingsRouteName,
  AssetSettingsRouteName,
  DepartmentSettingsRouteName,
  FleetSettingsRouteName,
  HardwareDevicesSettingsRouteName,
  OnCallRouteName,
  TagSettingsRouteName,
  TripSettingsRouteName,
} from './settings-route-names';
import { IntegrationSettingsRouteName } from '@pages/settings-page/integration-settings/integration-settings.routes';

export const SettingsRouteName = {
  Main: 'settings',
};
export const SETTINGS_ROUTES: Routes = [
  {
    path: '',
    component: SettingsPageComponent,
  },
  {
    path: DepartmentSettingsRouteName.Main,
    loadChildren: () =>
      import('./department-settings/departmet-settings.routes').then(
        m => m.DEPARTMENT_SETTINGS_ROUTES
      ),
  },
  {
    path: TripSettingsRouteName.Main,
    loadChildren: () =>
      import('./trip-settings/trip-settings.routes').then(
        m => m.TRIP_SETTINGS_ROUTES
      ),
  },
  {
    path: AccessControlSettingsRouteName.Main,
    loadChildren: () =>
      import('./access-control-settings/access-control-settings.routes').then(
        r => r.ACCESS_CONTROL_SETTINGS_ROUTES
      ),
  },
  {
    path: TagSettingsRouteName.Main,
    loadChildren: () =>
      import('./tag-settings/tag-settings.routes').then(
        m => m.TAG_SETTINGS_ROUTES
      ),
  },
  {
    path: AlertSettingsRouteName.Main,
    loadChildren: () =>
      import('./alerts-settings/alert-settings.routes').then(
        m => m.ALERT_SETTINGS_ROUTES
      ),
  },
  {
    path: HardwareDevicesSettingsRouteName.Main,
    loadChildren: () =>
      import('./hardware-devices-settings/hardware-devices-settings.routes').then(
        m => m.HARDWARE_DEVICES_SETTINGS_ROUTES
      ),
  },
  {
    path: AssetSettingsRouteName.Main,
    loadChildren: () =>
      import('./assets-settings/asset-settings.routes').then(
        m => m.ASSET_SETTINGS_ROUTES
      ),
  },
  {
    path: IntegrationSettingsRouteName.Main,
    loadChildren: () =>
      import('@pages/settings-page/integration-settings/integration-settings.routes').then(
        m => m.INTEGRATION_SETTINGS_ROUTES
      ),
  },
  {
    path: OnCallRouteName.Main,
    loadChildren: () =>
      import('./on-call-settings/on-call-settings.routes').then(
        r => r.ON_CALL_SETTINGS_ROUTES
      ),
  },
  {
    path: FleetSettingsRouteName.Main,
    loadChildren: () =>
      import('./fleet-settings/fleet-settings.routes').then(
        r => r.FLEET_SETTINGS_ROUTES
      ),
  },
];
